import { Controller } from "@hotwired/stimulus"
import { renderStreamMessage } from "@hotwired/turbo";

// Connects to data-controller="combined-schools-additional-studying-applications"
export default class extends Controller {
  static targets = ['inputCode', 'removeEl', 'addedCode']

  // 入力した科目コードから科目を取得し、テーブルに行追加
  addRowInCourseTable() {
    const query = new URLSearchParams()
    query.set('input_code', this.inputCodeTarget.value)
    this.addedCodeTargets.forEach(x => query.append('added_codes[]', x.innerText))

    fetch(`add_row_in_course_table?${query}`, { headers: { "Accept": "text/vnd.turbo-stream.html" } })
      .then(resonse => resonse.text())
      .then(message => {
        renderStreamMessage(message)
      })
  }

  // チェックされた科目の要素を削除する
  destroyRowInCourseTable() {
    for(const checkBoxEl of this.removeElTargets) {
      if(checkBoxEl.checked) { checkBoxEl.closest("tr").remove() }
    }
  }
}
